import { REQUEST_URL, APP_KEY } from "const";
import BMF from "src/utils/fileMd5.js";
import { mapMutations, mapState } from "vuex";
import { checkToken } from "../api/token";
import store from "../store";

export default {
  data() {
    return {
      uploadMaxLimitSize: sessionStorage.getItem("uploadParams")
        ? JSON.parse(sessionStorage.getItem("uploadParams"))
        : null, //最大上传文件大小
      printable: 0,
      uploadUrl: `${REQUEST_URL}/printDocConvert/uploadConvert`,
      header: {
        appKey: APP_KEY,
        token: localStorage.getItem("token")
          ? JSON.parse(localStorage.getItem("token")).token
          : "",
        Authorization: `Bearer ${store.state.user.accessToken}`
      },
      allFileType:
        ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg,.bmp,.PDF,.DOC,.DOCX,.XLS,.XLSX,.PPT,.PPTX,.PNG,.JPG,.JPEG"
    };
  },
  computed: {
    ...mapState("batch", ["uploadLists", "isUploading"])
  },
  watch: {
    uploadLists: {
      handler(n) {
        if (!n) return 0;
        // 仅仅是初步判断可打印的文件，后续上传完成可能code变成-1，所以此值可能存在偏大
        this.printable = n.filter(
          item => item.response && item.response.code === 0
        ).length;
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations("batch", [
      "SET_UPLOAD_LISTS",
      "UPDATE_UPLOAD_FILE_PERCENTAGE",
      "SET_IS_UPLOADING"
    ]),
    // ie10 同名文件需要clear
    clearUpload() {
      const ele = this.$refs.uploader.$el.getElementsByTagName("input")[0];
      const form = document.createElement("form");
      const beforInput = ele.nextSibling;
      const parentInput = ele.parentNode;
      form.appendChild(ele);
      form.reset();
      parentInput.insertBefore(ele, beforInput);
    },
    // 移除
    removeFile(uid) {
      const file =
        this.currentFiles && this.currentFiles.find(item => item.uid === uid);
      if (file) this.$refs.uploader.abort(file);
    },
    // 设置错误项 iscloudDoc 云文档上传不需要 reject
    setError(file, msg, isCloudDoc) {
      const errorItem = {
        name: file.name,
        percentage: 100,
        response: {
          code: -1,
          msg: msg
        },
        uid: file.uid,
        size: file.size,
        status: "success"
      };
      const index = this.uploadLists.findIndex(item => item.uid === file.uid);
      this.uploadLists.splice(index, 1, errorItem);
      this.SET_UPLOAD_LISTS(this.uploadLists);
      if (!isCloudDoc) return Promise.reject();
    },
    // 获取md5值
    getFileMd5(file) {
      return new Promise((resolve, reject) => {
        BMF.md5(file, (err, md5) => {
          if (err && !md5) {
            reject();
          } else {
            resolve(md5);
          }
        });
      });
    },
    //上传文件之前
    async beforeAvatarUpload(file, fileList) {
      this.clearUpload();
      if (!this.isUploading) this.SET_IS_UPLOADING(true);
      this.dragleaveFn && this.dragleaveFn();
      this.$emit("update:showCurrency", false);
      // this.printable 计算属性异步滞后不可用
      if (
        this.uploadLists.filter(
          item => item.response && item.response.code === 0
        ).length >= 10
      ) {
        if (!this.showAlert) {
          this.showAlert = true; // 开关 避免多次进入
          this.$alert({
            title: "提示",
            description: "批量打印最多支持10个文件",
            callback: () => {
              this.showAlert = false;
            }
          });
        }
        return Promise.reject();
      }
      // fileList为该组件成功上传的文件列表，在此业务场景中用不到
      const tempFile = {
        name: file.name,
        size: file.size,
        percentage: 0,
        uid: file.uid,
        response: {
          code: 0
        }
      };
      let fileListArr = [tempFile, ...this.uploadLists];
      // 更新上传进度列表
      this.SET_UPLOAD_LISTS(fileListArr);
      if (!this.allFileType.includes(this.interceptingFileTypes(file.name))) {
        return this.setError(file, "不支持的格式");
      }
      //文件大小
      let isAllowFileSize;
      for (let item of this.uploadMaxLimitSize) {
        if (item.paramKey === "uploadMaxLimit") {
          isAllowFileSize = file.size < Number(item.paramValue);
        }
      }
      if (!isAllowFileSize) {
        return this.setError(file, "文件大小超出限制");
      }
      try {
        const md5 = await this.getFileMd5(file);
        this.uploadParameter.md5 = md5;
        this.uploadParameter.fileName = file.name;
      } catch (e) {
        console.log(e);
        return this.setError(file, "文件md5获取失败");
      }
      try {
        if (localStorage.getItem("loginType") !== "iam") {
          // 实时判断token是否过期需要刷新
          await checkToken();
          this.header.token = localStorage.getItem("token")
            ? JSON.parse(localStorage.getItem("token")).token
            : "";
        } else {
          this.header.Authorization = `Bearer ${store.state.user.accessToken}`;
        }
      } catch (e) {
        this.$message.error("认证信息过期");
        localStorage.clear();
        window.location.reload();
        return Promise.reject();
      }
    },
    //上传文件进度
    uploadProgress(event, file, fileList) {
      const { uid, percentage } = file;
      if (this.uploadLists.find(item => item.uid === file.uid)) {
        // 已存在只需要更新进度，否则多文件会闪屏
        this.UPDATE_UPLOAD_FILE_PERCENTAGE({
          uid,
          percentage
        });
      }
    },
    //文件上传成功回调
    success(response, file, fileList) {
      const { uid, percentage, response: res } = file;
      this.UPDATE_UPLOAD_FILE_PERCENTAGE({
        uid,
        percentage,
        response: res
      });
      // if (!response.ret && response.code === 0) {
      //   this.percentage = 100;
      //   //查询转换文档信息
      //   this.fileQueryFn(response.data.printNo);
      // } else {
      //   this.$refs.uploader.clearFiles();
      //   this.progressColor = "#ff0036";
      // }
    },
    filesChange(file, files) {
      if (!this.currentFiles) this.currentFiles = [];
      this.currentFiles.push(file);
    }
  }
};
